import type { SVGProps } from 'react';
const SvgCirclesTarget = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <circle cx={12} cy={12} r={9} strokeWidth={2} />
    <circle cx={12} cy={12} r={4} />
  </svg>
);
export default SvgCirclesTarget;
